<template>
    <div class="content">
        <div class="contract-header" v-if="$route.query.isMail != 1 && $route.query.isApp == 1">
            <div v-if="$route.query.isApp == 1">
                <img :class="{ mirrorRotateLevel: isDirection }" @click.stop="goBack" v-if="$route.query.backgroundColor == 'day'" src="../assets/images/contractPoint/arrow-moon1.png">
                <img :class="{ mirrorRotateLevel: isDirection }" @click.stop="goBack" v-else src="../assets/images//contractPoint/arrow-day1.png">
            </div>
        </div>
        <!-- <div class="contract-header">
            <div>
                <img :class="{ mirrorRotateLevel: isDirection }" @click.stop="goBack" v-if="$route.query.backgroundColor == 'day'" src="../assets/images/contractPoint/arrow-moon1.png">
                <img :class="{ mirrorRotateLevel: isDirection }" @click.stop="goBack" v-else src="../assets/images//contractPoint/arrow-day1.png">
            </div>
        </div> -->
        <div class="newBg">
            <div class="noActBg" v-if="startTime_act == null">
                <img src="../assets/images/contractPoint/noActBg_h5.png">
                <!-- 暂无正在进行的活动，敬请期待... -->
                <span>{{$t('9100046')}}</span>
            </div>
            <div v-else>
                <div class="header">
                    <div>
                        <div class="shdowText1Box">
                            <div class="shdowText1" :class="langShdowText1()">
                                <!-- 攒积分，得空投 -->
                                {{$t('9100001')}},{{$t('9100002')}},{{$t('9100047')}}
                                <div class="top" :class="langShdowText1()">{{$t('9100001')}},{{$t('9100002')}},{{$t('9100047')}}</div>
                                <div class="bottom" :class="langShdowText1()">{{$t('9100001')}},{{$t('9100002')}},{{$t('9100047')}}</div>
                            </div>
                        </div>

                        <div class="headerText">
                            <!-- 交易积分是获取平台代币SCS的唯一渠道 9100058 -->
                            {{$t('9100058')}}
                        </div>
                        <!-- <div data-text="我是文字、你好" class="shdowText">我是文字、你好</div> -->
                        <div class="activity_list">
                            <div class="activity_list_box">
                                <div class="activity_item header_title1">
                                    <img :class="languageText1()" v-if="$route.query.backgroundColor == 'day'" src="../assets/images/contractPoint/pointIcon1.png">
                                    <img :class="languageText1()" v-else src="../assets/images/contractPoint/pointIcon1-sunlight.png">
                                    <span>{{$t('9100001')}}</span>
                                </div>
                                <div class="activity_item header_title2">
                                    <img src="../assets/images/contractPoint/pointIcon2.png">
                                    {{$t('9100002')}}
                                </div>
                                <div class="activity_item header_title2">
                                    <img :class="languageText()" src="../assets/images/contractPoint/pointIcon3.png">
                                    {{$t('9100003')}}
                                </div>
                            </div>
                            <div>
                                <img :class="{ mirrorRotateLevel: isDirection }" class="titleImg" :src="h5Img">
                            </div>
                        </div>
                    </div>
                </div>
                <div id="bgTop" class="bg">
                    <!-- <pointLoading v-show="loading"></pointLoading> -->
                    <div class="points_details" :style="{'background-image': getBackgroundImage()}">
                        <div class="points_header">
                            <div class="title">{{$t('9100004')}}</div>
                            <div class="detail">
                                <div class="number">{{isLogin ? formatNumber(availableAmount) : '--'}}</div>
                                <div class="to_detail" @click="goPointsDetails">

                                    {{$t('9100005')}}

                                    <i style="display:inline-block" :class="{ mirrorRotateLevel: isDirection }" class="iconfont history icon-gengduo"></i>
                                </div>
                            </div>
                        </div>
                        <div class="points_type_list">
                            <div class="points_type_item">
                                <div class="label">{{$t('9100006')}}</div>
                                <div class="value" @click="goPoint_1">
                                    <div class="number">
                                        {{ isLogin ? formatNumber(signPointsAmount): '--'}}
                                    </div>
                                    <!-- <i style="display:inline-block" :class="{ mirrorRotateLevel: isDirection }" class="iconfont history icon-gengduo"></i> -->
                                    <img :class="{ mirrorRotateLevel: isDirection }" src="../assets/images//contractPoint/goRightH5.png">
                                </div>
                            </div>
                            <div class="points_type_item">
                                <div class="label">{{$t('9100007')}}</div>
                                <div class="value" @click="goPoint_2">
                                    <div class="number">
                                        {{isLogin ? formatNumber(tradePointsAmount) : '--'}}
                                    </div>
                                    <img :class="{ mirrorRotateLevel: isDirection }" src="../assets/images//contractPoint/goRightH5.png">
                                </div>
                            </div>
                            <div class="points_type_item">
                                <div class="label">{{$t('9100008')}}</div>
                                <div class="value" @click="goPoint_3">
                                    <div class="number">
                                        {{isLogin ? formatNumber(invitePointsAmount) : '--'}}
                                    </div>
                                    <img :class="{ mirrorRotateLevel: isDirection }" src="../assets/images//contractPoint/goRightH5.png">
                                </div>
                            </div>
                            <div class="points_type_item">
                                <div class="label">{{$t('9100009')}}</div>
                                <div class="value" @click="goPoint_4">
                                    <div class="number">
                                        {{isLogin ? formatNumber(rewardPointsAmount) : '--'}}
                                    </div>
                                    <img :class="{ mirrorRotateLevel: isDirection }" src="../assets/images//contractPoint/goRightH5.png">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="isOpenPoint == true" class="pointsMsgHeight"></div>
                    <div class="pointsMsg" v-show="isOpenPoint == 0">
                        <span>{{$t('9100033')}}</span>
                    </div>
                    <div class="get_points_title">
                        <div class="title_left">
                            <div class="title_icon"></div>
                            <div class="title_text">{{$t('9100032')}}</div>
                        </div>
                        <div class="title_right">
                            <div class="tranBox" v-if="isOpenPoint == true" @click="failPoint = true"></div>
                            <van-switch v-model="isOpenPoint" @change="handleChangeStatus" active-color="#FFC72B"></van-switch>
                        </div>
                    </div>

                    <div class="sign_points">
                        <div class="sign_header">
                            <div v-if="$route.query.backgroundColor == 'day'" class="icon iconDay"></div>
                            <div v-else class="icon iconMoon"></div>
                            <div class="open_btn" @click="openSignSpeedBox = !openSignSpeedBox">
                                <div class="open_btn-text openIcon">{{$t('9100006')}}</div>
                                <div class="open_btn_icon" :class="{open:openSignSpeedBox}">
                                    <img v-if="$route.query.backgroundColor == 'day'" src="../assets/images/contractPoint/arrow-moon.png">
                                    <img v-else src="../assets/images/contractPoint/arrow-day.png">
                                </div>
                            </div>
                        </div>
                        <div class="sign_info">{{$t('9100034')}}</div>
                        <div class="sign_speed_box" :class="{open:openSignSpeedBox}">
                            <div v-for="(item,index) in noTokenMsgList" :key="index" class="sign_speed_item" :class="{reach : index+1 <= continueDay}">
                                <div v-if="index+1 <= continueDay" class="points_box" @click="goContract_1">
                                    <div class="icon_1"></div>
                                    <div class="icon_2"></div>
                                </div>
                                <div v-else class="points_box" @click="goContract_1">
                                    <div class="icon_3"></div>
                                    <div class="points_num">{{item.amount }}</div>

                                </div>
                                <div class="day_box">
                                    DAY{{item.day}}
                                </div>

                            </div>
                            <div class="sign_speed_line" :class="{ mirrorRotateLevel: isDirection }">
                                <div :style="{right: `${100 / 6 * ( 7 - continueDay)}%`}" class="sign_speed_line_reach"></div>
                                <div v-for="item in 7" :key="item" class="sign_speed_circle" :class="{reach : item <= continueDay}" :style="{left: `${100 / 6 * (item-1)}%`}"></div>
                            </div>
                        </div>
                        <!-- <div class="sign_info_1">已连续交易 {{token ? continueDay : '--'}} 天获得 {{token ? amountSignIn : '--'}} 积分</div> -->
                        <div class="sign_info_1">{{$t('9100015',{day:isLogin ? continueDay : '--',num:isLogin ? formatNumber(amountSignIn) : '--'})}}</div>

                        <div class="to_trade_btn" @click="goContract_1">{{$t('300083')}}</div>
                    </div>

                    <div class="points_type_item_two">
                        <div class="sign_header">
                            <div v-if="$route.query.backgroundColor == 'day'" class="icon iconDay"></div>
                            <div v-else class="icon iconMoon"></div>
                            <div class="open_btn">
                                <div class="open_btn-text">{{$t('9100007')}}</div>
                                <svg @click="isShowNewBox1 = true" class="icon tishigantan" aria-hidden="true" style="cursor: pointer;">
                                    <use xlink:href="#icon-tishi-copy"></use>
                                </svg>
                            </div>
                        </div>
                        <div class="sign_info">{{$t('9100035')}}</div>
                        <div class="sign_info_1">
                            <!-- 今日已得 {{token ? tradePointsAmount_day : '--'}} 积分 -->
                            {{$t('9100016',{num:isLogin ? formatNumber(tradePointsAmount_day) : '--'})}}
                        </div>
                        <div class="to_trade_btn" @click="goContract_2">{{$t('300083')}}</div>
                    </div>
                    <div class="points_type_item_two">
                        <div class="sign_header">
                            <div v-if="$route.query.backgroundColor == 'day'" class="icon iconDay"></div>
                            <div v-else class="icon iconMoon"></div>
                            <div class="open_btn">
                                <div class="open_btn-text">{{$t('9100036')}}</div>
                                <svg @click="isShowNewBox2 = true" class="icon tishigantan" aria-hidden="true" style="cursor: pointer;">
                                    <use xlink:href="#icon-tishi-copy"></use>
                                </svg>
                            </div>
                        </div>
                        <div class="sign_info">{{$t('9100037')}}</div>
                        <div class="sign_info_1">
                            <!-- 今日已得 {{token ? rankPointsAmount_day : '--'}} 积分 -->
                            {{$t('9100016',{num:isLogin ? formatNumber(rankPointsAmount_day) : '--'})}}
                        </div>
                        <div class="to_trade_btn" @click="goContract_3">{{$t('300083')}}</div>
                    </div>
                    <div class="points_type_item_two">
                        <div class="sign_header">
                            <div v-if="$route.query.backgroundColor == 'day'" class="icon iconDay"></div>
                            <div v-else class="icon iconMoon"></div>
                            <div class="open_btn">
                                <div class="open_btn-text">{{$t('9100008')}}</div>
                                <svg @click="isShowNewBox3 = true" class="icon tishigantan" aria-hidden="true" style="cursor: pointer;">
                                    <use xlink:href="#icon-tishi-copy"></use>
                                </svg>
                            </div>
                        </div>
                        <div class="sign_info">{{$t('9100038')}}</div>
                        <div class="sign_info_1">
                            <!-- 今日已得 {{token ? invitePointsAmount_day : '--'}} 积分 -->
                            {{$t('9100016',{num:isLogin ? formatNumber(invitePointsAmount_day) : '--'})}}
                        </div>
                        <div class="to_trade_btn" @click="goContract_4">{{$t('300069')}}</div>
                    </div>

                    <div class="points_rule">
                        <div class="text" @click="goPointRuler">{{$t('9100012')}}</div>
                        <i style="display:inline-block" :class="{ mirrorRotateLevel: isDirection }" class="iconfont history icon-gengduo rulerArw"></i>
                    </div>

                    <div class="wheelLottery">
                        <div class="wheelLottery-title">
                            <img src="../assets/images/contractPoint/wheelIcon.png">
                            <div class="titleText">{{$t('9100010')}}</div>
                        </div>
                        <div class="wheelLottery-content">
                            <div class="notice-bar" v-if="winList.length>0">
                                <van-swipe vertical class="notice-swipe" :autoplay="1500" :show-indicators="false">
                                    <van-swipe-item v-for="(item,index) in winList" :key="index">
                                        <img :class="{mirrorRotateLevel:isDirection}" src="../../static/images/congratulations.png" alt />
                                        <!-- <p>{{ item.account }}已经中奖<span style="color:#D9A31A"> {{item.pointAmount}} 积分</span></p> -->
                                        <p v-html="$t('9100039',{guy:item.account,num:formatNumber(item.pointAmount)})"></p>
                                    </van-swipe-item>
                                </van-swipe>
                            </div>
                            <div class="LuckyWheel">
                                <img class="LuckyWheel-img" src="../assets/images/contractPoint/wheelBg.png">
                                <div class="LuckyWheel-content">
                                    <!-- <LuckyWheel ref="myLucky" width="330px" height="330px" :prizes="prizes" :blocks="blocks" :buttons="buttons" @start="startCallback" @end="endCallback" /> -->
                                    <div class="drawBox">
                                        <div ref="drwaImg" class="drawImg" alt="">
                                            <div v-for="(item,index) in wheelPointList" :key="index" class="num" :style="{left:`${item.x}%`,top:`${item.y}%`,transform: ` translateX(-50%) translateY(-50%) rotate(${item.jiaodu}deg)`}">
                                                <!-- {{wheelPointList.length >=8  ? prizes[7-index].drawAmount : ''}} -->
                                                {{wheelPointList.length >= 8 && prizes[7-index] && prizes[7-index].drawAmount ? prizes[7-index].drawAmount : ''}}
                                            </div>
                                        </div>
                                        <img class="ss" src="../assets/images/contractPoint/wheelBtn.png" alt="">
                                    </div>
                                </div>
                                <div class="wheelFloor">
                                    <img class="wheelFloor-img" src="../assets/images/contractPoint/wheelFloor.png">
                                    <div class="wheelFloorText1">{{formatNumber(numberPrize)}}</div>
                                    <div class="wheelFloorText2">{{$t('9100017')}}</div>
                                </div>
                            </div>
                            <div class="wheelLottery-content-text">
                                <div>{{$t('9100004')}}：{{isLogin ? availableAmount : '--'}}</div>
                                <div class="wheelLotteryText2">{{$t('9100019')}}：{{isLogin ? drawsNumber : '--'}}/{{maxDailyDraws}}</div>
                                <div>
                                    <!-- · 每次抽奖消耗{{pointsPerDrawAmount}}積分，每天最多抽{{maxDailyDraws}}次。 -->
                                    <span v-if="language === 'ru' || language === 'uk'" class="pointText">-</span>
                                    <span v-else class="pointText">·</span>
                                    {{$t('9100018',{point:formatNumber(pointsPerDrawAmount),num:maxDailyDraws})}}
                                </div>
                            </div>
                            <!-- 立即抽奖 -->
                            <div class="wheelLotteryBtn" @click="startCallback">{{$t('9100040')}}</div>
                        </div>
                    </div>

                    <!-- 排行榜 -->
                    <div class="rankContent">
                        <div class="rankContent-title">
                            <img class="rankContent-title-img" src="../assets/images/contractPoint/rankIcon.png">
                            <div class="rankContent-title-text">{{$t('300070')}}</div>
                        </div>
                        <div class="rankContent-content">
                            <div class="rankContent-content-title">
                                <div>{{$t('300084')}}</div>
                                <div class="rankDiv2">{{$t('9100020')}}</div>
                                <div class="rankDiv3">{{$t('9100021')}}</div>
                            </div>
                            <div class="rankContent-content-list">
                                <div class="rankScrollbar">
                                    <div class="rankListListMain" v-for="(item,index) in rankList" :key="index" :class="{ 'lastItem': index === rankList.length - 1 }">
                                        <div class="listMainIcon">
                                            <div class="listMainIcon-img" :style="{ 'background-image': getBackgroundImageIcon(index) }">
                                                <span>{{index + 1}}</span>
                                            </div>
                                        </div>
                                        <div class="listMainTest rankText2">
                                            <span>{{item.account}}</span>
                                        </div>
                                        <div class="listMainTest rankText3">
                                            <span>{{formatNumber(item.pointAmount)}}</span>
                                        </div>
                                    </div>
                                </div>
                                <van-empty class="custom-image" :description="$t('300108')" v-show="rankList.length == 0">
                                    <svg slot="image" class="icon emptyIcon" aria-hidden="true">
                                        <use :xlink:href="$route.query.backgroundColor == 'day' ? '#icon-jilu1' : '#icon-zanwujilu'"></use>
                                    </svg>
                                </van-empty>
                            </div>
                        </div>
                    </div>

                    <van-popup class="newBox1" v-model="isShowNewBox1">
                        <div class="rewardModel">
                            <div class="rewardModel-main">
                                <div class="rewardModel-main-title">
                                    <span>{{$t('9100007')}}</span>
                                    <svg @click="isShowNewBox1 = false" class="icon arrow" aria-hidden="true">
                                        <use xlink:href="#icon-guanbi1"></use>
                                    </svg>
                                </div>
                                <div class="rewardModel-main-content">
                                    <!-- 1.用户在合约市场产生的所有交易行为即可获取积分  9100035 -->
                                    1.{{$t('9100035')}}
                                    <br>
                                    <!-- 可获积分=交易额*1%（难度随着平台总交易量的上升会进一步调整） 9100055-->
                                    {{$t('9100055')}}
                                    <br>
                                    <br>
                                    <!-- 例如：用户使用保证金100USDT*100X=10000U的仓位 9100056 -->
                                    2.{{$t('9100056')}}<br>
                                    <br>
                                    <!-- 那么只需要100USDT的保证金即可获得100积分 -->
                                    3.{{$t('9100057')}}
                                </div>
                            </div>
                        </div>
                    </van-popup>

                    <van-popup class="newBox2" v-model="isShowNewBox2">
                        <div class="rewardModel">
                            <div class="rewardModel-main">
                                <div class="rewardModel-main-title">
                                    <span>{{$t('9100036')}}</span>
                                    <svg @click="isShowNewBox2 = false" class="icon arrow" aria-hidden="true">
                                        <use xlink:href="#icon-guanbi1"></use>
                                    </svg>
                                </div>
                                <div class="rewardModel-main-content">
                                    <!-- 每日交易排行榜前五给与额外的奖励积分 9100037-->
                                    1.{{$t('9100037')}}<br>
                                    <br>
                                    <!-- 额外奖励积分=当日积分总额*名次奖励比例 9100059 -->
                                    2.{{$t('9100059')}}<br>
                                    <!-- :class="isStyleTable()" -->
                                    <table class="rankTable">
                                        <tr>
                                            <td>
                                                <!-- 名次 9100060 -->
                                                {{$t('9100060')}}
                                            </td>
                                            <td class="rankTd2">
                                                <!-- 奖励积分 9100009 -->
                                                {{$t('9100009')}}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <!-- 第一名 9100061 -->
                                                {{$t('9100061')}}
                                            </td>
                                            <td class="rankTd2">20%</td>
                                        </tr>
                                        <tr>
                                            <!-- 第二名 -->
                                            <td>{{$t('9100062')}}</td>
                                            <td class="rankTd2">10%</td>
                                        </tr>
                                        <tr>
                                            <!-- 第三名 -->
                                            <td>{{$t('9100063')}}</td>
                                            <td class="rankTd2">5%</td>
                                        </tr>
                                        <tr>
                                            <!-- 第四名 -->
                                            <td>{{$t('9100064')}}</td>
                                            <td class="rankTd2">3%</td>
                                        </tr>
                                        <tr>
                                            <!-- 第五名 -->
                                            <td>{{$t('9100065')}}</td>
                                            <td class="rankTd2">1%</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </van-popup>

                    <van-popup class="newBox3" v-model="isShowNewBox3">
                        <div class="rewardModel">
                            <div class="rewardModel-main">
                                <div class="rewardModel-main-title">
                                    <span>{{$t('9100008')}}</span>
                                    <svg @click="isShowNewBox3 = false" class="icon arrow" aria-hidden="true">
                                        <use xlink:href="#icon-guanbi1"></use>
                                    </svg>
                                </div>
                                <div class="rewardModel-main-content">
                                    <!-- 被邀请人产生积分，邀请人可获得奖励积分 -->
                                    {{$t('9100066')}}<br>
                                    <br>
                                    <!-- 计算公式：获得推广积分= 被邀请人获得积分 * 等级系数 9100068 -->
                                    {{$t('9100068')}}
                                    <br>
                                    <br>
                                    <!-- 等级系数会根据实际情况进行调整  9100069 -->
                                    {{$t('9100069')}}
                                    <br>
                                    <br>
                                    <!-- 例如：用户B参与积分活动，其邀请人为用户A，且用户A邀请数量等级已达到Level3，用户B累计获得积分=360,000；  9100070 -->
                                    {{$t('9100070')}}
                                    <br>
                                    <br>
                                    <!-- 那么用户A累计可获的推广积分=360000* 30%=108,000    9100071 -->
                                    {{$t('9100071')}}
                                    <div class="levelTitle">
                                        <!-- 等级系数 9100067-->
                                        {{$t('9100067')}}
                                    </div>
                                    <table class="invTable" border="1">
                                        <tr>
                                            <td class="td1">{{$t('9100060')}}</td>
                                            <td class="td2">{{$t('9100072')}}</td>
                                            <td class="td3"></td>
                                        </tr>
                                        <tr>
                                            <td class="td1">1</td>
                                            <td class="td2">15%</td>
                                            <td class="td3">{{$t('9100073')}}</td>
                                        </tr>
                                        <tr>
                                            <td class="td1">2</td>
                                            <td class="td2">20%</td>
                                            <!-- 交易量达到500W -->
                                            <td class="td3">{{$t('9100074')}}</td>
                                        </tr>
                                        <tr>
                                            <td class="td1">3</td>
                                            <td class="td2">30%</td>
                                            <!-- 交易量达到2000W -->
                                            <td class="td3">{{$t('9100075')}}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </van-popup>

                    <!-- 积分规则 -->
                    <van-popup class="rulerBox" v-model="isShowPointRuler">
                        <div class="rewardModel">
                            <div class="rewardModel-main">
                                <div class="rewardModel-main-title">
                                    <span>{{$t('9100012')}}</span>
                                    <svg @click="closePointRuler" class="icon arrow" aria-hidden="true">
                                        <use xlink:href="#icon-guanbi1"></use>
                                    </svg>
                                </div>
                                <div class="rewardModel-main-content">
                                    <p v-html="rulerMsg"></p>
                                </div>
                            </div>
                        </div>
                    </van-popup>

                    <!--积分余额不足-->
                    <van-popup v-model="noPoints" class="tip-popup" :style="{ width: '15.6rem',padding: '1.2rem' }" round>
                        <div>
                            <svg slot="image" class="icon boxIcon" aria-hidden="true">
                                <use xlink:href="#icon-tishi-1"></use>
                            </svg>
                            <p>{{$t('9100022')}}</p>
                            <p>{{$t('9100023')}}</p>
                            <van-button class="confirmBtn" @click="noPointsConfirm">{{$t('9100032')}}</van-button>
                            <van-button class="cancalBtn" @click="noPoints = false">{{$t('300111')}}</van-button>
                        </div>
                    </van-popup>

                    <!--抽奖次数已达上限-->
                    <van-popup v-model="noNumber" class="tip-popup" :style="{ width: '15.6rem',padding: '1.2rem' }" round>
                        <div>
                            <svg slot="image" class="icon boxIcon" aria-hidden="true">
                                <use xlink:href="#icon-tishi-1"></use>
                            </svg>
                            <p>{{$t('9100024')}}</p>
                            <p>{{$t('9100025')}}</p>
                            <van-button class="confirmBtn" @click="noNumber = false">{{$t('300286')}}</van-button>
                        </div>
                    </van-popup>

                    <!--如何获得积分-->
                    <van-popup v-model="getPoints" class="tip-popup" :style="{ width: '15.6rem',padding: '1.2rem' }" round>
                        <div>
                            <svg slot="image" class="icon boxIcon" aria-hidden="true">
                                <use xlink:href="#icon-tishi-1"></use>
                            </svg>
                            <p>{{$t('9100026')}}</p>
                            <!-- 报名参与合约交易获积分活动，才能获得积分 -->
                            <p>{{$t('9100027')}}</p>
                            <!-- 参与报名 -->
                            <van-button class="confirmBtn" @click="getPointsConfirm">{{$t('9100044')}}</van-button>
                            <!-- 继续交易 -->
                            <van-button class="cancalBtn" @click="tranAgain">{{$t('9100045')}}</van-button>
                        </div>
                    </van-popup>

                    <!--参与报名成功-->
                    <van-popup v-model="sucPoint" class="tip-popup" :style="{ width: '15.6rem',padding: '1.2rem' }" round>
                        <div>
                            <svg slot="image" class="icon boxIcon" aria-hidden="true">
                                <use xlink:href="#icon-tishi-1"></use>
                            </svg>
                            <p>{{$t('9100028')}}</p>
                            <p>{{$t('9100029')}}</p>
                            <van-button class="confirmBtn" @click="toSucPoint">{{$t('300083')}}</van-button>
                            <!-- 留在此页 -->
                            <van-button class="cancalBtn" @click="sucPoint = false">{{$t('9100043')}}</van-button>
                        </div>
                    </van-popup>

                    <!--参与报名成功 2.0 没取消-->
                    <van-popup v-model="sucPoint2" class="tip-popup" :style="{ width: '15.6rem',padding: '1.2rem' }" round>
                        <div>
                            <svg slot="image" class="icon boxIcon" aria-hidden="true">
                                <use xlink:href="#icon-tishi-1"></use>
                            </svg>
                            <p>{{$t('9100028')}}</p>
                            <p>{{$t('9100029')}}</p>
                            <van-button class="confirmBtn" @click="toSucPoint">{{$t('300083')}}</van-button>
                        </div>
                    </van-popup>

                    <!--取消报名-->
                    <van-popup v-model="failPoint" class="tip-popup" :style="{ width: '15.6rem',padding: '1.2rem' }" round>
                        <div>
                            <svg slot="image" class="icon boxIcon" aria-hidden="true">
                                <use xlink:href="#icon-tishi-1"></use>
                            </svg>
                            <p class="bold">{{$t('9100030')}}</p>
                            <van-button class="confirmBtn" @click="failPointConfirm">{{$t('300287')}}</van-button>
                            <van-button class="cancalBtn" @click="failPoint = false">{{$t('300111')}}</van-button>
                        </div>
                    </van-popup>

                    <!-- 抽奖成功 -->
                    <van-popup class="sucPointsBox" v-model="ishowSevenFinishBg">
                        <div class="finishModel" :class="['finishModel', {'finishModel-fa': language === 'fa'}]">
                            <div class="finishModel-img">
                                <!-- 恭喜您获得了 -->
                                <span>{{$t('9100041')}}</span>
                                <div class="getPoints_box">
                                    <span class="span_1">{{formatNumber(getSucPoints)}}</span>
                                    <span class="span_2">{{$t('9100021')}}</span>
                                </div>
                                <div class="finishModelBtn">
                                    <!-- 我知道了 -->
                                    <div class="again" @click="wheelAgain">{{$t('300286')}}</div>
                                </div>
                            </div>
                            <svg @click="ishowSevenFinishBg = false" class="icon finishModelIcon" aria-hidden="true">
                                <use xlink:href="#icon-guanbi2"></use>
                            </svg>
                        </div>
                    </van-popup>
                </div>
                <div class="bottomBox">

                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import { mapGetters } from 'vuex'
    import { Swipe, SwipeItem, Switch, Popup, Button, Empty, Toast } from 'vant'
    import {
        rankList,
        isOpenPoint,
        pointRuler,
        totalUserRewardData,
        userConfigBalance,
        UserDailyData,
        numberPrize,
        winInformation,
        wheelPoint,
        pointLottery,
        noTokeMsg,
        userSignIn,
    } from '../api/contractPoint.js'
    import { setToken, getCookie, removeToken, setCookie } from '../utils/auth'
    import { parseTime } from '../utils/index'
    import { getLanguageList } from '../api/user'
    // import pointLoading from '../compontents/pointLoading.vue'
    export default {
        name: 'contractPoint',
        components: {
            VanSwipe: Swipe,
            VanSwipeItem: SwipeItem,
            VanSwitch: Switch,
            vanPopup: Popup,
            vanButton: Button,
            vanEmpty: Empty,
            // pointLoading,
        },
        data() {
            return {
                isShowNewBox1: false,
                isShowNewBox2: false,
                isShowNewBox3: false,
                language: '',
                startTime_act: '',
                // loading: false,
                h5Img: '',
                availableAmount: '--', //积分余额
                //签到积分
                signPointsAmount: '--',
                //交易积分
                tradePointsAmount: '--',
                //邀请积分
                invitePointsAmount: '--',
                //奖励积分
                rewardPointsAmount: '--',

                signPoints_day: '', //签到积分_每日
                tradePointsAmount_day: '--', //交易积分_每日
                rankPointsAmount_day: '--', //邀请积分_每日
                invitePointsAmount_day: '--', //奖励积分_每日

                drawsNumber: '', //今日已抽奖次数
                isOpenPoint: false, //是否开启积分
                maxDailyDraws: '', //每天抽奖最多抽奖次数
                pointsPerDrawAmount: '', //每次抽奖消耗的积分数
                continueDay: 0, //签到天数
                numberPrize: '--', //奖池总数

                noPoints: false, //积分不足弹框
                noNumber: false, //次数不足弹框
                getPoints: false, //如何获得积分
                getSucPoints: '', //抽到的积分

                isShowPointRuler: false,
                isShowPointDetail: false,
                activeNames: '',
                openSignSpeedBox: true,
                timer:null,
                isApp: '',
                prizes: [],
                rankList: [],
                wheelPointList: [
                    {
                        // prize: '20',
                        x: 61,
                        y: 23,
                        jiaodu: 110,
                    },
                    {
                        // prize: '50',
                        x: 78,
                        y: 39,
                        jiaodu: 150,
                    },
                    {
                        // prize: '100',
                        x: 77,
                        y: 62,
                        jiaodu: 200,
                    },
                    {
                        // prize: '500',
                        x: 61,
                        y: 78,
                        jiaodu: 250,
                    },
                    {
                        // prize: '1000',
                        x: 39,
                        y: 78,
                        jiaodu: 292,
                    },
                    {
                        // prize: '2000',
                        x: 22,
                        y: 61,
                        jiaodu: 340,
                    },
                    {
                        // prize: '5000',
                        x: 22,
                        y: 38,
                        jiaodu: 26,
                    },
                    {
                        // prize: '20000',
                        x: 38,
                        y: 22,
                        jiaodu: 67,
                    },
                ],
                winList: [], //中奖信息列表
                amountSignIn: '--', //签到积分
                noTokenMsgList: [],
                deg: 360 / 8, // 每个奖品所占度数 ，圆盘360度
                prize: '', // 奖品
                truns: 0, // 转的圈数
                flag: false, //避免重复点击

                ishowSevenFinishBg: false,
                sucPoint: false,
                sucPoint2: false,
                failPoint: false,
                rulerMsg: '',
                isLogin: '',
            }
        },
        created() {
            console.log('10.26-----');
            console.log(this.language, 'language-language');
            console.log(this.$route.query.language == 'ru', 'this.$route.----');
            this.resher()
        },
        mounted() { },
        beforeDestroy() {
            clearInterval(this.timer)
        },
        computed: {
            ...mapGetters(['token', 'isDirection', 'language']),
        },
        watch: {
            // loading(newVal) {
            //     if (newVal) {
            //         document.body.style.overflow = 'hidden';
            //     } else {
            //         document.body.style.overflow = 'auto';
            //     }
            // },
            $route() {
                this.resher()
            },
        },
        methods: {
            // isTrueHeight() {
            //     if (this.$route.query.isApp == 1) {
            //         return 'appHeight'
            //     } else {
            //         return 'h5Height'
            //     }
            // },
            testAppSpot(){
                console.log('去现货');
                this.$jsBridge.callHandler(this.$jsBridgeCmd.appSpot, {code: 200,symbol:"btc_usdt"}, (data) => {
                })
            },
            langShdowText1() {
                if (this.$route.query.language == 'ru') {
                    return 'ruLangShdowText'
                } else if (this.$route.query.language == 'es') {
                    return 'ruLangShdowText'
                } else if (this.$route.query.language == 'uk') {
                    return 'ruLangShdowText'
                } else if (this.$route.query.language == 'vi') {
                    return 'ruLangShdowText'
                }
            },
            isStyleTable() {
                if (this.$route.query.backgroundColor == 'day') {
                    return 'dayBorder'
                } else {
                    return 'moonBorder'
                }
            },
            resher() {
                console.log(this.token, 'created----token')
                console.log(this.$route.path, 'this.$route.path')
                console.log(this.$route.query, 'this.$route.query')
                this.isApp = this.$route.query.isApp
                let token = this.$route.query.token || this.token
                setCookie(
                    'language',
                    this.$route.query.language ? this.$route.query.language : 'en'
                )
                this.language = this.$route.query.language
                    ? this.$route.query.language
                    : 'en'
                this.$store.dispatch(
                    'setIsDirection',
                    this.$route.query.language == 'fa' ? true : false
                )
                if (this.$route.query.backgroundColor != '') {
                    window.document.documentElement.setAttribute(
                        'data-theme',
                        this.$route.query.backgroundColor === 'day'
                            ? 'sunlight'
                            : 'moon'
                    )
                } else {
                    window.document.documentElement.setAttribute(
                        'data-theme',
                        'moon'
                    )
                }
                window.document.documentElement.setAttribute(
                    'dir',
                    this.isDirection ? 'rtl' : 'ltr'
                )
                this.getNoTokeMsg()
                this.getPointRuler()
                this.getNumberPrize()
                this.timer = setInterval(() => {
                    this.getNumberPrize()
                }, 10000)
                this.getWheelPoint()
                this.getRankList()
                this.getWinInformation() //中奖信息
                if (this.isApp == 1) {
                    this.$i18n.locale = this.language
                    if (token) {
                        setToken(token)
                        this.$store.dispatch('GetInfo', token)
                        this.$store.dispatch('setToken', token)
                        this.isLogin = true
                        this.getTotalUserRewardData() //用户奖励总数据（四个积分）
                        this.getUserConfigBalance() //用户配置及余额
                        this.getUserDailyData() //用户每日数据
                        this.getUserSignIn() //用户签到
                    } else {
                        console.log('这里')
                        removeToken()
                        this.isLogin = false
                    }
                } else {
                    this.isLogin = getCookie('token') ? true : false
                    if (this.isLogin) {
                        this.getTotalUserRewardData() //用户奖励总数据（四个积分）
                        this.getUserConfigBalance() //用户配置及余额
                        this.getUserDailyData() //用户每日数据
                        this.getUserSignIn() //用户签到
                    } else {
                        removeToken()
                    }
                }
            },
            formatNumber(num) {
                const decimalPart = num % 1
                if (decimalPart === 0) {
                    return parseInt(num)
                } else {
                    return num
                }
            },
            languageText() {
                if (
                    this.language === 'fr' ||
                    this.language === 'es' ||
                    this.language === 'uk'
                ) {
                    return 'frHeaderText'
                }
            },
            languageText1() {
                if (this.language === 'fr') {
                    return 'frHeaderText1'
                }
            },
            goBackApp() {
                this.$jsBridge.callHandler(
                    this.$jsBridgeCmd.goBack,
                    {},
                    (data) => { }
                )
            },
            goBack() {
                if (this.$route.query.isBanner == 0) {
                    let isApp =
                        this.$route.query.isApp || this.isApp ? '&isApp=1' : ''
                    this.$router.push(`/activity?language=${this.language}${isApp}`)
                } else {
                    this.goBackApp()
                }
            },
            isAppContract() {
                if (this.$route.query.isApp == 1) {
                    this.$jsBridge.callHandler(
                        this.$jsBridgeCmd.appContract,
                        { code: 200 },
                        (data) => { }
                    )
                } else {
                    this.$router.push('/downLoad')
                }
            },
            goContract_1() {
                analytics.track("Ordinary Button Clicked",{
                    trigger:'h5_trade_point_page_trade_button'
                });
                // if (!this.token) {
                //     this.appLogin()
                // } else if (this.isOpenPoint == false) {
                //     this.getPoints = true
                // } else {
                //     this.isAppContract()
                // }
                if (this.$route.query.token || this.token) {
                    console.log(this.$route.query.token, 'this.$route.query.token')
                    console.log(this.token, 'this.token')
                    console.log(this.isOpenPoint, 'this.isOpenPoint')
                    if (this.isOpenPoint == false) {
                        this.getPoints = true
                    } else {
                        this.isAppContract()
                    }
                } else {
                    this.appLogin()
                }
            },
            goContract_2() {
                analytics.track("Ordinary Button Clicked",{
                    trigger:'h5_trade_point_page_trade_button'
                });
                if (this.$route.query.token || this.token) {
                    if (this.isOpenPoint == false) {
                        this.getPoints = true
                    } else {
                        this.isAppContract()
                    }
                } else {
                    this.appLogin()
                }
            },
            goContract_3() {
                analytics.track("Ordinary Button Clicked",{
                    trigger:'h5_trade_point_page_trade_button'
                });
                if (this.$route.query.token || this.token) {
                    if (this.isOpenPoint == false) {
                        this.getPoints = true
                    } else {
                        this.isAppContract()
                    }
                } else {
                    this.appLogin()
                }
            },
            goContract_4() {
                analytics.track("Ordinary Button Clicked",{
                    trigger:'h5_trade_point_page_invite_button'
                });
                // if (!this.token) {
                //     this.appLogin()
                // } else {
                //     if (this.$route.query.isApp == 1) {
                //         this.$jsBridge.callHandler(
                //             this.$jsBridgeCmd.goInvite,
                //             { code: 200 },
                //             (data) => {}
                //         )
                //     } else {
                //         this.$router.push('/downLoad')
                //     }
                // }
                if (this.$route.query.token || this.token) {
                    if (this.$route.query.isApp == 1) {
                        this.$jsBridge.callHandler(
                            this.$jsBridgeCmd.goInvite,
                            { code: 200 },
                            (data) => { }
                        )
                    } else {
                        this.$router.push('/downLoad')
                    }
                } else {
                    this.appLogin()
                }
            },
            //报名成功-去交易
            toSucPoint() {
                this.isAppContract()
            },
            failPointConfirm() {
                this.handleChangeStatus3()
                this.failPoint = false
            },
            //积分余额不足-获得积分
            noPointsConfirm() {
                console.log(this.isOpenPoint, '--isOpenPoint--')
                if (this.isOpenPoint == true) {
                    this.noPoints = false
                    this.isAppContract()
                } else {
                    console.log('没开-- ')
                    this.noPoints = false
                    this.handleChangeStatus2()
                    // this.sucPoint2 = true
                    // const scrollTop = document.getElementById('bgTop')
                    // console.log(scrollTop, 'scrollTop')
                    // scrollTop.scrollIntoView()
                }
            },
            //如何获得积分-参与报名
            getPointsConfirm() {
                this.handleChangeStatus2()
                this.getPoints = false
            },
            tranAgain() {
                this.isAppContract()
                this.getPoints = false
            },
            goPointsDetails() {
                if (this.$route.query.isApp == 1) {
                    if (this.$route.query.token) {
                        this.$router.push({
                            path: '/pointsDetails',
                            query: {
                                token: this.$route.query.token,
                                isApp: this.$route.query.isApp,
                                backgroundColor: this.$route.query.backgroundColor,
                            },
                        })
                    } else {
                        this.appLogin()
                    }
                } else {
                    if (this.token) {
                        this.$router.push({ path: '/pointsDetails' })
                    } else {
                        this.$router.push('/login')
                    }
                }
            },
            goPoint_1() {
                // if (this.$route.query.token || this.token) {
                //     this.$router.push({ path: '/pointsDetails', query: { backgroundColor: this.$route.query.backgroundColor, type: 1, isApp: this.$route.query.isApp } });
                // } else {
                //     this.appLogin()
                // }
                if (this.$route.query.isApp == 1) {
                    if (this.$route.query.token) {
                        this.$router.push({
                            path: '/pointsDetails',
                            query: {
                                token: this.$route.query.token,
                                isApp: this.$route.query.isApp,
                                backgroundColor: this.$route.query.backgroundColor,
                                type: 1,
                            },
                        })
                    } else {
                        this.appLogin()
                    }
                } else {
                    if (this.token) {
                        this.$router.push({ path: '/pointsDetails' })
                    } else {
                        this.$router.push('/login')
                    }
                }
            },
            goPoint_2() {
                if (this.$route.query.isApp == 1) {
                    if (this.$route.query.token) {
                        this.$router.push({
                            path: '/pointsDetails',
                            query: {
                                token: this.$route.query.token,
                                isApp: this.$route.query.isApp,
                                backgroundColor: this.$route.query.backgroundColor,
                                type: 2,
                            },
                        })
                    } else {
                        this.appLogin()
                    }
                } else {
                    if (this.token) {
                        this.$router.push({ path: '/pointsDetails' })
                    } else {
                        this.$router.push('/login')
                    }
                }
            },
            goPoint_3() {
                if (this.$route.query.isApp == 1) {
                    if (this.$route.query.token) {
                        this.$router.push({
                            path: '/pointsDetails',
                            query: {
                                token: this.$route.query.token,
                                isApp: this.$route.query.isApp,
                                backgroundColor: this.$route.query.backgroundColor,
                                type: 3,
                            },
                        })
                    } else {
                        this.appLogin()
                    }
                } else {
                    if (this.token) {
                        this.$router.push({ path: '/pointsDetails' })
                    } else {
                        this.$router.push('/login')
                    }
                }
            },
            goPoint_4() {
                if (this.$route.query.isApp == 1) {
                    if (this.$route.query.token) {
                        this.$router.push({
                            path: '/pointsDetails',
                            query: {
                                token: this.$route.query.token,
                                isApp: this.$route.query.isApp,
                                backgroundColor: this.$route.query.backgroundColor,
                                type: 4,
                            },
                        })
                    } else {
                        this.appLogin()
                    }
                } else {
                    if (this.token) {
                        this.$router.push({ path: '/pointsDetails' })
                    } else {
                        this.$router.push('/login')
                    }
                }
            },
            //格式化时间
            parseTime(time, type) {
                if (time) {
                    return parseTime(time, type)
                } else {
                    return '--'
                }
            },
            wheelAgain() {
                this.ishowSevenFinishBg = false
            },
            //new wheel
            startCallback() {
                if (this.flag) {
                    return
                }
                analytics.track("Ordinary Button Clicked",{
                    trigger:'h5_trade_point_page_lottery_button'
                });
                this.flag = true
                if (this.$route.query.token || this.token) {
                    pointLottery().then((res) => {
                        console.log(res, 'res..')
                        if (res.code == 20002) {
                            const formatNumber = (num) => {
                                const decimalPart = num % 1
                                if (decimalPart === 0) {
                                    return parseInt(num)
                                } else {
                                    return num
                                }
                            }
                            this.truns = this.truns + 3
                            //重置位置
                            this.$refs.drwaImg.style.transition = ''
                            // this.$refs.drwaImg.style.transform = `rotate(0deg)`
                            this.$refs.drwaImg.style.transition = 'all 1s linear'
                            this.$refs.drwaImg.style.transform = `rotate(${this.truns * 360
                                }deg)`
                            this.getSucPoints = res.data
                            this.$refs.drwaImg.style.transition = 'all 5s ease-out'
                            const index = this.prizes.findIndex(
                                (item) =>
                                    item.drawAmount.toString() ===
                                    formatNumber(res.data).toString()
                            )
                            console.log(index, 'index----index')
                            this.$refs.drwaImg.style.transform = `rotate(${this.truns * 360 + this.deg * index + this.deg / 2
                                }deg)`
                            setTimeout(() => {
                                this.getUserConfigBalance()
                                this.getNumberPrize()
                                this.flag = false
                            }, 5000)
                            setTimeout(() => {
                                this.ishowSevenFinishBg = true
                            }, 5000)
                        } else if (res.code == 500) {
                            //奖池余额不足，请稍后再试
                            this.flag = false
                        } else if (res.code == 121023) {
                            this.noNumber = true
                            this.flag = false
                        } else if (res.code == 121022) {
                            this.noPoints = true
                            this.flag = false
                        } else if (res.code == 51013) {
                            console.log('活动已结束')
                            Toast(res.msg)
                            this.flag = false
                        } else if (res.code == 51011) {
                            console.log('没开始不能抽')
                            Toast(res.msg)
                        }
                    })
                } else {
                    this.appLogin()
                }
            },
            //未登录背景板
            getNoTokeMsg() {
                noTokeMsg().then((res) => {
                    console.log(res)
                    this.noTokenMsgList = res.data
                })
            },
            //用户签到
            getUserSignIn() {
                userSignIn().then((res) => {
                    console.log(res)
                    this.continueDay = res.data.continueDay || 0
                    this.amountSignIn = res.data.amount || '--'
                })
            },
            //中奖信息
            getWinInformation() {
                winInformation().then((res) => {
                    console.log(res, '中奖信息的res')
                    this.winList = res.data
                })
            },
            //排行榜信息
            getRankList() {
                rankList().then((res) => {
                    console.log(res, 'res')
                    this.rankList = res.data
                    console.log(this.rankList, 'this.rankList')
                })
            },
            //转盘上的积分信息
            getWheelPoint() {
                wheelPoint().then((res) => {
                    console.log(res, '转盘上的res')
                    this.prizes = res.data
                })
            },
            //用户每日数据
            getUserDailyData() {
                UserDailyData().then((res) => {
                    console.log(res, '用户每日数据的res')
                    // this.signPoints_day = res.data.signPoints  //签到积分
                    this.tradePointsAmount_day = res.data.tradePoints || '--' //交易积分
                    this.rankPointsAmount_day = res.data.rankPoints || '--' //排行榜积分
                    this.invitePointsAmount_day = res.data.invitePoints || '--' //邀请积分
                })
            },
            //用户奖励总数据（四个积分）
            getTotalUserRewardData() {
                totalUserRewardData().then((res) => {
                    // console.log(res, '用户奖励总数据（四个积分）的res');
                    //签到积分
                    this.signPointsAmount = res.data.signPointsAmount || '--'
                    //交易积分
                    this.tradePointsAmount = res.data.tradePointsAmount || '--'
                    //邀请积分
                    this.invitePointsAmount = res.data.invitePointsAmount || '--'
                    //奖励积分
                    this.rewardPointsAmount = res.data.rewardPointsAmount || '--'
                })
            },
            //奖池数量总额
            getNumberPrize() {
                numberPrize().then((res) => {
                    console.log(res, '奖池数量总额的res')
                    this.numberPrize = res.data || '--'
                })
            },
            //积分规则
            getPointRuler() {
                pointRuler().then((res) => {
                    // console.log(res, '活动总览');
                    this.rulerMsg = res.data.rule //规则
                    this.pointsPerDrawAmount = res.data.pointsPerDraw //每次抽奖消耗的积分数
                    this.maxDailyDraws = res.data.maxDailyDraws //每天抽奖最多抽奖次数
                    this.h5Img = res.data.h5Img //h5Img
                    this.startTime_act = res.data.startTime //活动开始时间
                })
            },
            //用户配置及余额
            getUserConfigBalance() {
                userConfigBalance().then((res) => {
                    // console.log(res, '用户配置及余额的res');
                    // this.availableAmount = res.data.availableAmount == '' ? '--' : res.data.availableAmount //可用积分
                    this.availableAmount = res.data.availableAmount || '--'
                    // if(this.isLogin){
                    //     this.availableAmount = this.availableAmount || '--'
                    // }else{
                    //     this.availableAmount = '--'
                    // }
                    this.drawsNumber = res.data.drawsNumber //今日已抽奖次数
                    this.isOpenPoint = res.data.state == 1 ? true : false //活动开启状态
                    if (res.data.state === null || res.data.state === undefined) {
                        this.isOpenPoint = false
                    }
                })
            },
            handleChangeStatus() {
                if (this.$route.query.token || this.token) {
                    console.log('有token的时候')
                    console.log(this.isOpenPoint, 'this.isOpenPoint')
                    isOpenPoint().then((res) => {
                        console.log(res, 'res---')
                        if (res.code == 20002) {
                            console.log('走的是这里吗');
                            analytics.track("Ordinary Button Clicked",{
                                 status: 'in',
                                 trigger:'h5_trade_point_page_join_button'
                                 });
                            this.sucPoint = true
                            this.getRankList()
                            this.getUserConfigBalance()
                        } else if (res.code == 121021) {
                            Toast(res.msg)
                            console.log('进了吗')
                            this.getUserConfigBalance()
                        } else if (res.code == 51013) {
                            console.log('活动已结束')
                            Toast(res.msg)
                            this.isOpenPoint == false
                            this.getUserConfigBalance()
                        } else if (res.code == 51011) {
                            console.log('没开始不能抽')
                            Toast(res.msg)
                            this.isOpenPoint == false
                            this.getUserConfigBalance()
                        }
                    })
                } else {
                    this.appLogin()
                }
            },
            handleChangeStatus2() {
                if (this.$route.query.token || this.token) {
                    console.log('有token的时候')
                    console.log(this.isOpenPoint, 'this.isOpenPoint')
                    isOpenPoint().then((res) => {
                        console.log(res, 'res---')
                        if (res.code == 20002) {
                            this.sucPoint2 = true
                            this.getRankList()
                            this.getUserConfigBalance()
                        } else if (res.code == 121021) {
                            Toast(res.msg)
                            console.log('进了吗')
                            this.getUserConfigBalance()
                            this.isAppContract()

                        } else if (res.code == 51013) {
                            console.log('活动已结束')
                            Toast(res.msg)
                            this.isOpenPoint == false
                            this.getUserConfigBalance()
                        } else if (res.code == 51011) {
                            console.log('没开始不能抽')
                            Toast(res.msg)
                            this.isOpenPoint == false
                            this.getUserConfigBalance()
                        }
                    })
                } else {
                    this.appLogin()
                }
            },
            handleChangeStatus3() {
                if (this.$route.query.token || this.token) {
                    console.log('有token的时候')
                    console.log(this.isOpenPoint, 'this.isOpenPoint')
                    isOpenPoint().then((res) => {
                        console.log(res, 'res---')
                        if (res.code == 20002) {
                            analytics.track("Ordinary Button Clicked",{
                                    status:'out',
                                    trigger:'h5_trade_point_page_join_button'
                                    });
                            this.getRankList()
                            this.getUserConfigBalance()
                        } else if (res.code == 121021) {
                            Toast(res.msg)
                            console.log('进了吗')
                            this.getUserConfigBalance()
                        } else if (res.code == 51013) {
                            console.log('活动已结束')
                            Toast(res.msg)
                            this.isOpenPoint == false
                            this.getUserConfigBalance()
                        } else if (res.code == 51011) {
                            console.log('没开始不能抽')
                            Toast(res.msg)
                            this.isOpenPoint == false
                            this.getUserConfigBalance()
                        }
                    })
                } else {
                    this.appLogin()
                }
            },
            appLogin() {
                if (this.$route.query.isApp == 1 || this.isApp == 1) {
                    this.$jsBridge.callHandler(
                        this.$jsBridgeCmd.appLogin,
                        {
                            code: 200,
                            type: 'login',
                        },
                        (data) => { }
                    )
                } else {
                    this.$router.push({
                        path: '/login',
                        query: {
                            historyBack: `/contractPoint`,
                        },
                    })
                }
            },
            goPointRuler() {
                this.isShowPointRuler = true
            },
            closePointRuler() {
                this.isShowPointRuler = false
            },
            getBackgroundImage() {
                // 根据 this.$route.query.backgroundColor 的值返回不同的背景图片路径
                if (this.$route.query.backgroundColor == 'day') {
                    return 'url("../assets/images/contractPoint/bg_points_details_2.png")'
                } else {
                    return 'url("../assets/images/contractPoint/bg_points_details_1.png")'
                }
            },
            getBackgroundImageIcon(index) {
                let backgroundImage = ''
                switch (index + 1) {
                    case 1:
                        backgroundImage = `url(${require('../assets/images/rankOneIcon.png')})`
                        break
                    case 2:
                        backgroundImage = `url(${require('../assets/images/rankTwoIcon.png')})`
                        break
                    case 3:
                        backgroundImage = `url(${require('../assets/images/rankThreeIcon.png')})`
                        break
                    default:
                        backgroundImage = `url(${require('../assets/images/rankOtherIcon.png')})`
                }
                return backgroundImage
            },
        },
    }
</script>
<style lang="scss" scoped>
    @import "../assets/css/variableName";
    @import "../style/mixin";
    @import "../assets/css/mixin";
    //正常
    [dir="ltr"] {
        .header {
            // padding-left: torem(16);
            .shdowText {
                text-align: left;
            }
            .activity_list {
                .activity_item {
                    // padding-left: torem(42);
                    // padding-left: torem(22);
                    img {
                        margin-right: torem(5);
                    }
                }
            }
        }
        .points_details {
            .points_header {
                .detail {
                    .number {
                        margin-right: torem(24);
                    }
                    .to_detail {
                        > i {
                            margin-left: torem(5);
                        }
                    }
                }
            }
            .points_type_list {
                .points_type_item {
                    .value {
                        .number {
                            margin-right: torem(16);
                        }
                    }
                }
            }
        }
        .sign_points {
            .sign_header {
                .icon {
                    margin-right: torem(8);
                }
                .open_btn {
                    .openIcon {
                        margin-right: torem(8);
                    }
                    &-text {
                        text-align: left;
                    }
                }
            }
            .sign_info {
                text-align: left;
            }
            .sign_speed_box {
                .sign_speed_item {
                    .points_box {
                        .points_num {
                            text-align: left;
                        }
                    }
                }
                .sign_speed_line {
                    left: torem(12);
                    right: torem(20);
                }
            }
        }
        .points_type_item_two {
            .sign_header {
                .icon {
                    margin-right: torem(8);
                }
                .open_btn {
                    &-text {
                        text-align: left;
                    }
                }
            }
            .sign_info {
                text-align: left;
            }
        }
        .wheelLottery {
            &-title {
                .titleText {
                    text-align: left;
                    margin-left: torem(8);
                }
            }
            &-content {
                .notice-bar {
                    /deep/ .van-swipe-item {
                        img {
                            margin-right: torem(10);
                        }
                    }
                }
                &-text {
                    text-align: left;
                }
                .wheelLotteryBtn {
                    text-align: left;
                }
            }
        }
        .rankContent {
            &-title {
                &-text {
                    margin-left: torem(8);
                    text-align: left;
                }
            }
            &-content {
                &-title {
                    .rankDiv2 {
                        margin-left: torem(16);
                    }
                    .rankDiv3 {
                        text-align: right;
                    }
                }
                &-list {
                    .rankListListMain {
                        .rankText2 {
                            margin-left: torem(16);
                        }
                        .rankText3 {
                            text-align: right;
                        }
                    }
                }
            }
        }
        .rulerBox {
            .rewardModel {
                &-main {
                    &-title {
                        span {
                            text-align: left;
                        }
                    }
                }
            }
        }
        .sucPointsBox {
            .finishModel {
                &-img {
                    background-image: url("../assets/images/contractPoint/sevenFinishBg.png");
                    .again {
                        left: torem(26);
                    }
                }
                .finishModelIcon {
                    left: 47%;
                }
            }
        }
        .pointsMsg {
            span {
                text-align: left;
            }
        }
        .pointText {
            margin-right: torem(5);
        }
        .tishigantan {
            margin-left: torem(8);
        }
        .invTable td {
            padding-left: torem(8);
        }
        .rankTable td {
            padding-left: torem(8);
        }
        .rankTd2 {
            text-align: right;
            padding-right: torem(8);
        }
        .newBox1 .rewardModel-main-content {
            text-align: left;
        }
        .newBox2 .rewardModel-main-content {
            text-align: left;
        }
        .newBox3 .rewardModel-main-content {
            text-align: left;
        }
    }
    //镜像
    [dir="rtl"] {
        .header {
            // padding-right: torem(16);
            .shdowText {
                text-align: right;
            }
            .activity_list {
                .activity_item {
                    padding-left: torem(12);
                    img {
                        margin-left: torem(5);
                    }
                }
            }
        }
        .points_details {
            .points_header {
                .detail {
                    .number {
                        margin-left: torem(24);
                    }
                    .to_detail {
                        > i {
                            margin-right: torem(5);
                        }
                    }
                }
            }
            .points_type_list {
                .points_type_item {
                    .value {
                        .number {
                            margin-left: torem(16);
                        }
                    }
                }
            }
        }
        .sign_points {
            .sign_header {
                .icon {
                    margin-left: torem(8);
                }
                .open_btn {
                    .openIcon {
                        margin-left: torem(8);
                    }
                    &-text {
                        text-align: right;
                    }
                }
            }
            .sign_info {
                text-align: right;
            }
            .sign_speed_box {
                .sign_speed_item {
                    .points_box {
                        .points_num {
                            text-align: left;
                        }
                    }
                }
                .sign_speed_line {
                    right: torem(12);
                    left: torem(20);
                }
            }
        }
        .points_type_item_two {
            .sign_header {
                .icon {
                    margin-left: torem(8);
                }
                .open_btn {
                    &-text {
                        text-align: right;
                    }
                }
            }
            .sign_info {
                text-align: right;
            }
        }
        .wheelLottery {
            &-title {
                .titleText {
                    text-align: right;
                    margin-right: torem(8);
                }
            }
            &-content {
                .notice-bar {
                    /deep/ .van-swipe-item {
                        img {
                            margin-left: torem(10);
                        }
                    }
                }
                &-text {
                    text-align: right;
                }
                .wheelLotteryBtn {
                    text-align: right;
                }
            }
        }
        .rankContent {
            &-title {
                &-text {
                    margin-right: torem(8);
                    text-align: right;
                }
            }
            &-content {
                &-title {
                    .rankDiv2 {
                        margin-right: torem(16);
                    }
                    .rankDiv3 {
                        text-align: left;
                    }
                }
                &-list {
                    .rankListListMain {
                        .rankText2 {
                            margin-right: torem(16);
                        }
                        .rankText3 {
                            text-align: left;
                        }
                    }
                }
            }
        }
        .rulerBox {
            .rewardModel {
                &-main {
                    &-title {
                        span {
                            text-align: right;
                        }
                    }
                }
            }
        }
        .sucPointsBox {
            .finishModel {
                &-img {
                    background-image: url("../assets/images/contractPoint/sevenFinishBg-fa.png");
                    .again {
                        right: torem(26);
                    }
                }
                .finishModelIcon {
                    right: 47%;
                }
            }
        }
        .pointsMsg {
            span {
                text-align: right;
            }
        }
        .pointText {
            margin-left: torem(5);
        }
        .tishigantan {
            margin-right: torem(8);
        }
        .invTable td {
            padding-right: torem(8);
        }
        .rankTable td {
            padding-right: torem(8);
        }
        .rankTd2 {
            text-align: left;
            padding-left: torem(8);
        }
        .newBox1 .rewardModel-main-content {
            text-align: right !important;
        }
        .newBox2 .rewardModel-main-content {
            text-align: right !important;
        }
        .newBox3 .rewardModel-main-content {
            text-align: right !important;
        }
    }
</style>
<style lang="scss" scoped>
    @import "../assets/css/variableName";
    @import "../style/mixin";
    @import "../assets/css/mixin";
    .shdowText1Box {
        min-height: torem(55);
        .shdowText1 {
            position: relative;
            color: transparent;
            font-size: torem(28);
            line-height: 1.2;
            width: 100%;
            // max-width: torem(280);
            // min-width: torem(250);
            .top {
                z-index: 9;
                background: linear-gradient(to right, #ffe573, #fdba12);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                position: absolute;
                left: 0;
                top: 0;
                font-size: torem(28);
                font-weight: bold;
                width: 100%;
                // max-width: torem(280);
                // min-width: torem(250);
            }
            .bottom {
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                text-shadow: torem(1) torem(1) 0 #986d00;
                position: absolute;
                left: 0;
                top: 0;
                font-size: torem(28);
                font-weight: bold;
                width: 100%;
                // max-width: torem(280);
                // min-width: torem(250);
            }
        }
    }
</style>
<style lang="scss" scoped>
    @import "../assets/css/variableName";
    @import "../style/mixin";
    @import "../assets/css/mixin";
    .content {
        position: fixed;
        flex-direction: column;
        width: 100vw;
        height: 100vh;
        top: 0;
        left: 0;
        overflow: hidden;
    }
    .contract-header {
        width: 100%;
        z-index: 9999;
        padding: 0 torem(19);
        box-sizing: border-box;
        height: torem(44);
        @include background_color("background-color-4");
        display: flex;
        align-items: center;
        text-align: start;
        img {
            width: torem(16);
            height: torem(16);
        }
    }
    // .appHeight {
    //     height: calc(100% - #{torem(44)});
    // }
    // .h5Height {
    //     height: 100%;
    // }
    .newBg {
        // flex: 1;
        // overflow: auto;
        height: 100%;
        // padding-bottom: torem(20);
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }
    .header {
        // width: 100%;
        // display: flex;
        margin: 0 auto;
        position: relative;
        padding: torem(13) torem(16) 0 torem(16);
        @include background_color("background-color-4");
        .shdowText {
            font-size: torem(30);
            height: torem(36);
            font-family: Lato, Lato;
            font-weight: bold;
            line-height: torem(35);
            // text-shadow: torem(1) torem(1) torem(0) #ffb600;
            // text-align: left;
            font-style: normal;
            text-transform: none;
            color: #ffe573;
            background: linear-gradient(
                49.972824828354156deg,
                #ffe573 0%,
                #fdba12 100%
            );
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
        .activity_list {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            margin-top: torem(12);
            .activity_list_box {
                padding-bottom: torem(20);
            }
            .activity_item {
                position: relative;
                display: flex;
                align-items: center;
                width: torem(138);
                height: torem(24);
                @include background_color("background-color-5");
                margin-top: torem(4);
                // padding-left: torem(42);
                // @include font_color("font-color-3");
                font-size: torem(11);
                img {
                    color: rgba(255, 255, 255, 0.5);
                    font-size: torem(12);
                    width: torem(14);
                    height: torem(14);
                    // margin-right: torem(5);
                }
                &::before {
                    content: "";
                    position: absolute;
                    width: 0;
                    height: 0;
                    left: 0;
                    top: 0;
                    border: torem(12) solid transparent;
                    @include border_left_color("background-color-4");
                    border-left-width: torem(10);
                }
                &::after {
                    content: "";
                    position: absolute;
                    width: 0;
                    height: 0;
                    left: 100%;
                    top: 0;
                    border: torem(12) solid transparent;
                    @include border_left_color("background-color-5");
                    border-left-width: torem(10);
                }
            }
            .header_title1 {
                display: flex;
                justify-content: center;
                @include font_color("font-color-3");
            }
            .header_title2 {
                display: flex;
                justify-content: center;
                @include font_color("disale-color");
            }
        }
        .titleImg {
            height: torem(120);
        }
    }

    .headerBox {
        height: torem(44);
    }

    .noActBg {
        display: flex;
        padding-top: torem(156);
        align-items: center;
        flex-direction: column;
        @include background_color("background-color-4");
        width: 100%;
        height: 100vh;
        // min-height: calc(100vh - 248px);
        img {
            width: 120px;
            height: 120px;
        }
        span {
            margin-top: torem(24);
            //font
            font-family: Lato, Lato;
            font-weight: 400;
            font-size: torem(14);
            color: #7f8490;
            line-height: torem(16);
            text-align: left;
            font-style: normal;
            text-transform: none;
            max-width: torem(300);
        }
    }

    .bg {
        @include background_color("background-color-4");
        // background-color: #1b1c22;
        padding: 0 torem(16) torem(50) torem(16);
        .points_details {
            padding: torem(24) torem(14);
            border: torem(1) solid;
            @include border_color("border-color-2");
            border-radius: torem(8);
            @include background_color("background-color-6");
            font-size: torem(14);
            // color: rgba(255, 255, 255, 0.5);
            @include font_color("disale-color");
            // background-image: url("../assets/images/contractPoint/bg_points_details_2.png");
            background-size: torem(116) torem(116);
            background-repeat: no-repeat;
            background-position: bottom right;

            .points_header {
                .detail {
                    display: flex;
                    height: torem(30);
                    align-items: center;
                    margin-top: torem(10);
                    .number {
                        @include font_color("font-color-3");
                        font-size: torem(24);
                        // margin-right: torem(24);
                        font-weight: 800;
                    }
                    .to_detail {
                        display: flex;
                        align-items: center;
                        color: #d9a31a;
                        font-size: torem(14);
                        > i {
                            // color: #d9a31a;
                            font-size: torem(12);
                            width: torem(14);
                            height: torem(14);
                            margin-top: torem(3);
                            // margin-left: torem(5);
                        }
                    }
                }
            }
            .points_type_list {
                margin-top: torem(16);
                .points_type_item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin-bottom: torem(12);
                    height: torem(18);
                    .label {
                        font-size: torem(14);
                        // color: rgba(255, 255, 255, 0.5);
                        @include font_color("disale-color");
                        line-height: torem(16);
                    }
                    .value {
                        display: flex;
                        align-items: center;
                        .number {
                            font-weight: 600;
                            font-size: torem(14);
                            @include font_color("font-color-3");
                            // margin-right: torem(16);
                        }
                        img {
                            width: torem(9);
                            height: torem(12);
                        }
                    }
                }
            }
        }
        .pointsMsg {
            display: flex;
            justify-content: end;
            max-width: torem(343);
            margin-top: torem(12);
            span {
                max-width: torem(343);
                word-wrap: break-word;
                display: inline-block;
                // position: absolute;
                min-height: torem(28);
                line-height: torem(25);
                // top: torem(435);
                // right: torem(16);
                background: rgba(255, 199, 43, 0.1);
                border-radius: torem(14);
                border: torem(1) solid #d9a31a;
                padding: 0 torem(10);
                //font
                font-family: IBM Plex Sans, IBM Plex Sans;
                font-weight: 400;
                font-size: torem(14);
                color: #d9a31a;
                // text-align: right;
                font-style: normal;
                text-transform: none;
            }
        }
        .pointsMsgHeight {
            height: torem(40);
        }
        .get_points_title {
            height: torem(40);
            display: flex;
            justify-content: space-between;
            align-items: center;
            // margin-top: torem(36);
            .title_left {
                display: flex;
                align-items: center;
                .title_icon {
                    width: torem(28);
                    height: torem(28);
                    background-image: url("../assets/images/contractPoint/icon_get_points.png");
                    background-size: 100%;
                }
                .title_text {
                    font-weight: 800;
                    font-size: torem(20);
                    @include font_color("font-color-3");
                    margin-left: torem(8);
                }
            }
            .title_right {
                position: relative;
                .van-switch {
                    @include background_color("border-color-3");
                    width: torem(37);
                    height: torem(20);
                }
                /deep/ .van-switch__node {
                    margin-top: torem(2);
                    width: torem(15);
                    height: torem(15);
                    // @include background_color("border-color-4");
                    background-color: #ffffff;
                }
                /deep/ .van-switch--on .van-switch__node {
                    transform: translateX(36px);
                }
            }
        }
        .sign_points {
            padding: torem(14) torem(14);
            border-radius: torem(16);
            @include background_color("background-color-6");
            font-size: torem(14);
            color: rgba(255, 255, 255, 0.5);
            margin-top: torem(12);
            border: torem(1) solid;
            @include border_color("border-color-2");
            .sign_header {
                display: flex;
                align-items: center;
                .icon {
                    width: torem(20);
                    height: torem(20);
                    // background-image: url("../assets/images/contractPoint/icon_sign_header.png");
                    background-size: 100%;
                    // margin-right: torem(8);
                }
                .iconDay {
                    background-image: url("../assets/images/contractPoint/icon_sign_header2.png");
                }
                .iconMoon {
                    background-image: url("../assets/images/contractPoint/icon_sign_header.png");
                }
                .open_btn {
                    display: flex;
                    align-items: center;
                    .openIcon {
                        // margin-right: torem(8);
                    }
                    &-text {
                        font-family: Lato, Lato;
                        font-weight: 600;
                        font-size: torem(16);
                        @include font_color("font-color-3");
                        line-height: torem(19);
                        // text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }
                    .open_btn_icon {
                        img {
                            width: torem(9);
                            height: torem(12);
                            // margin-left: torem(8);
                        }
                        transform: rotate(90deg);
                        transition: all 0.5s;
                        &.open {
                            transform: rotate(-90deg);
                        }
                    }
                }
            }
            .sign_info {
                font-size: torem(14);
                font-family: Lato, Lato;
                font-weight: 400;
                @include font_color("disale-color");
                // text-align: left;
                font-style: normal;
                text-transform: none;
                line-height: torem(16);
                margin-top: torem(8);
            }
            .sign_speed_box {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-top: torem(16);
                position: relative;
                height: torem(0);
                overflow: hidden;
                transition: all 0.5s;
                opacity: 0.5;

                &.open {
                    height: torem(84);
                    opacity: 1;
                }

                .sign_speed_item {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    .points_box {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        width: torem(33);
                        height: torem(44);
                        @include background_color("background-color-7");
                        border-radius: torem(6);
                        border: torem(1) solid;
                        @include border_color("border-color-3");

                        .icon_1 {
                            width: torem(17);
                            height: torem(17);
                            background-image: url("../assets/images/contractPoint/icon_sign_list_1.png");
                            background-size: 100%;
                            margin-top: torem(5);
                        }
                        .icon_2 {
                            width: torem(12);
                            height: torem(10);
                            background-image: url("../assets/images/contractPoint/icon_sign_list_2.png");
                            background-size: 100%;
                            margin-top: torem(3);
                        }
                        .icon_3 {
                            width: torem(17);
                            height: torem(17);
                            background-image: url("../assets/images/contractPoint/icon_sign_list_3.png");
                            background-size: 100%;
                            margin-top: torem(4);
                        }
                        .points_num {
                            font-size: torem(12);
                            margin-top: torem(5);
                            font-family: Lato, Lato;
                            font-weight: 800;
                            @include font_color("disale-color");
                            line-height: 14px;
                            // text-align: left;
                            font-style: normal;
                            text-transform: none;
                        }
                    }

                    .day_box {
                        font-size: torem(12);
                        margin-top: torem(26);
                        @include font_color("disale-color");
                    }
                    &.reach {
                        .points_box {
                            background: linear-gradient(
                                140deg,
                                #ffe573 0%,
                                #fdba12 100%
                            );
                            border: torem(1) solid #ffe573;
                        }
                        .day_box {
                            color: #d9a31a;
                        }
                    }
                }
                .sign_speed_line {
                    position: absolute;
                    bottom: torem(22);
                    // left: torem(12);
                    // right: torem(20);
                    height: torem(2);
                    // background: rgba(255, 255, 255, 0.3);
                    @include background_color("border-color-3");
                    .sign_speed_line_reach {
                        position: absolute;
                        left: 0;
                        top: 0;
                        //   right: torem(20);
                        height: torem(2);
                        background: #ffc72b;
                    }
                    .sign_speed_circle {
                        position: absolute;
                        z-index: 2;

                        top: torem(-3);
                        width: torem(8);
                        height: torem(8);
                        // @include background_color("border-color-3");
                        @include background_color("font-color-11");
                        border-radius: 50%;
                        &.reach {
                            background: #ffc72b;
                        }
                    }
                }
            }
            .sign_info_1 {
                font-size: torem(14);
                @include font_color("font-color-3");
                line-height: torem(16);
                margin-top: torem(16);
                font-family: Lato, Lato;
                font-weight: 400;
                font-style: normal;
                text-transform: none;
            }
            .to_trade_btn {
                height: torem(44);
                background: linear-gradient(140deg, #ffe573 0%, #fdba12 100%);
                border-radius: torem(8);
                font-weight: 600;
                font-size: torem(16);
                color: #000922;
                line-height: torem(44);
                text-align: center;
                margin-top: torem(32);
            }
        }

        .points_type_item_two {
            padding: torem(14) torem(14);
            border: torem(1) solid;
            border-radius: torem(16);
            @include background_color("background-color-6");
            font-size: torem(14);
            @include border_color("border-color-2");
            color: rgba(255, 255, 255, 0.5);
            margin-top: torem(12);
            .sign_header {
                display: flex;
                align-items: center;
                .icon {
                    width: torem(20);
                    height: torem(20);
                    // background-image: url("../assets/images/contractPoint/icon_sign_header.png");
                    background-size: 100%;
                    // margin-right: torem(8);
                }
                .iconDay {
                    background-image: url("../assets/images/contractPoint/icon_sign_header2.png");
                }
                .iconMoon {
                    background-image: url("../assets/images/contractPoint/icon_sign_header.png");
                }
                .open_btn {
                    display: flex;
                    align-items: center;
                    &-text {
                        font-family: Lato, Lato;
                        font-weight: 600;
                        font-size: torem(16);
                        @include font_color("font-color-3");
                        line-height: torem(19);
                        // text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }
                }
            }
            .sign_info {
                font-size: torem(14);
                font-family: Lato, Lato;
                font-weight: 400;
                @include font_color("disale-color");
                // text-align: left;
                font-style: normal;
                text-transform: none;
                line-height: torem(16);
                margin-top: torem(8);
            }
            .sign_info_1 {
                font-size: torem(14);
                @include font_color("font-color-3");
                line-height: torem(16);
                margin-top: torem(16);
                font-family: Lato, Lato;
                font-weight: 400;
                font-style: normal;
                text-transform: none;
            }
            .to_trade_btn {
                height: torem(44);
                background: linear-gradient(140deg, #ffe573 0%, #fdba12 100%);
                border-radius: torem(8);
                font-weight: 600;
                font-size: torem(16);
                color: #000922;
                line-height: torem(44);
                text-align: center;
                margin-top: torem(16);
            }
        }
        .points_rule {
            display: flex;
            align-items: center;
            height: torem(44);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: torem(14);
            color: #d9a31a;
            .text {
                margin-right: torem(5);
            }
        }
        .wheelLottery {
            margin-top: torem(48);
            &-title {
                display: flex;
                align-items: center;
                img {
                    width: torem(28);
                    height: torem(28);
                }
                .titleText {
                    font-family: Lato, Lato;
                    font-weight: 800;
                    font-size: torem(20);
                    @include font_color("font-color-3");
                    line-height: torem(23);
                    // text-align: left;
                    font-style: normal;
                    text-transform: none;
                    // margin-left: torem(8);
                }
            }
            &-content {
                margin-top: torem(18);
                width: torem(343);
                // height: torem(488);
                border-radius: torem(16);
                border: torem(1) solid;
                padding: torem(16);
                @include background_color("background-color-6");
                @include border_color("border-color-2");
                .notice-bar {
                    z-index: 9;
                    padding: 0 torem(16);
                    width: auto;
                    line-height: torem(26);
                    height: torem(26);
                    @include background_color("background-color-7");
                    border-radius: torem(18);
                    @include font_color("font-color-4");
                    overflow: hidden;
                    font-size: torem(14);
                    //todo
                    display: flex;
                    align-items: center;
                    /deep/ .van-swipe-item {
                        display: flex;
                        width: torem(270);
                        align-items: center;
                        img {
                            // margin-right: torem(10);
                        }
                        p {
                            max-width: torem(270);
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                    }
                    .notice-swipe {
                        height: torem(30);
                        line-height: torem(30);
                    }
                    img {
                        width: torem(18);
                        height: torem(18);
                    }
                }
                .LuckyWheel {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    position: relative;
                    &-img {
                        position: absolute;
                        margin-top: torem(8);
                        width: torem(310);
                        height: torem(272);
                    }
                    &-content {
                        margin-top: torem(30);
                        .drawBox {
                            position: relative;
                            width: torem(217);
                            height: torem(217);
                            // background-color: aqua;
                            margin-top: torem(13);
                        }
                        .drawImg {
                            position: absolute;
                            top: 0;
                            border-radius: 50%;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            transform: rotate(0deg);
                            background-image: url("../assets/images/contractPoint/wheelBgtwo_new.png");
                            background-repeat: no-repeat;
                            background-size: 100% 100%;
                            /* transition: all 2s ease-out; */
                        }
                        .ss {
                            position: absolute;
                            width: 100px;
                            height: 117px;
                            top: 128px;
                            left: 50%;
                            transform: translateX(-50%);
                        }
                        .num {
                            position: absolute;
                            transform: translateX(-50%);
                            transform: translateY(-50%);

                            //font
                            font-family: TCloud Number, TCloud Number;
                            font-weight: bold;
                            font-size: 26px;
                            color: #ffffff;
                            line-height: 40px;
                            text-shadow: 0px 2px 0px #664718;
                            text-stroke: 1px #ffffff;
                            text-align: left;
                            font-style: normal;
                            text-transform: none;
                            -webkit-text-stroke: 1px #ffffff;

                            /* margin-top: -50%;
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              margin-left: -50%; */
                        }
                    }
                    .wheelFloor {
                        display: flex;
                        justify-content: center;
                        margin-top: torem(-15);
                        &-img {
                            position: relative;
                            width: torem(156);
                            height: torem(42);
                        }
                        .wheelFloorText1 {
                            position: absolute;
                            bottom: torem(17);
                            //font
                            font-family: Lato, Lato;
                            font-weight: 800;
                            font-size: torem(16);
                            color: #ffffff;
                            line-height: torem(19);
                            text-shadow: 0px torem(1) 0px #483504;
                            text-align: center;
                            font-style: normal;
                            text-transform: none;
                        }
                        .wheelFloorText2 {
                            position: absolute;
                            bottom: torem(8);
                            //font
                            font-family: Lato, Lato;
                            font-weight: 400;
                            font-size: torem(10);
                            color: #ffffff;
                            line-height: torem(12);
                            text-shadow: 0px torem(1) 0px #483504;
                            text-align: center;
                            font-style: normal;
                            text-transform: none;
                        }
                    }
                }
                &-text {
                    margin-top: torem(18);
                    // font-family: Lato, Lato;
                    font-family: Plus Jakarta Sans, Plus Jakarta Sans;
                    font-weight: 400;
                    font-size: torem(14);
                    @include font_color("disale-color");
                    line-height: torem(16);
                    // text-align: left;
                    font-style: normal;
                    text-transform: none;
                    .wheelLotteryText2 {
                        margin: torem(8) 0;
                    }
                }
                .wheelLotteryBtn {
                    margin-top: torem(12);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    width: torem(311);
                    height: torem(44);
                    background: linear-gradient(140deg, #ffe573 0%, #fdba12 100%);
                    border-radius: torem(8);
                    //font
                    font-family: Lato, Lato;
                    font-weight: 600;
                    font-size: torem(16);
                    color: #000922;
                    line-height: torem(19);
                    // text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
            }
        }
        .rankContent {
            margin-top: torem(48);
            margin-bottom: torem(35);
            &-title {
                display: flex;
                align-items: center;
                &-img {
                    width: torem(28);
                    height: torem(28);
                }
                &-text {
                    // margin-left: torem(8);
                    font-family: Lato, Lato;
                    font-weight: 800;
                    font-size: torem(20);
                    @include font_color("font-color-3");
                    line-height: torem(23);
                    // text-align: left;
                    font-style: normal;
                    text-transform: none;
                }
            }
            &-content {
                margin-top: torem(16);
                width: torem(343);
                // max-height: torem(697);

                &-title {
                    display: flex;
                    align-items: center;
                    height: torem(57);
                    border-radius: torem(16) torem(16) 0px 0px;
                    @include background_color("background-color-7");
                    padding: 0 torem(12);
                    div {
                        width: torem(111);
                        @include font_color("font-color-5");
                    }
                    .rankDiv2 {
                        // margin-left: torem(16);
                        width: torem(350);
                        // text-align: center;
                    }
                    .rankDiv3 {
                        // text-align: right;
                    }
                }
                .rankScrollbar {
                    // max-height: torem(640);
                    overflow-y: auto;
                }
                &-list {
                    @include background_color("background-color-2");
                    border-radius: 0px 0px torem(16) torem(16);
                    .rankListListMain {
                        display: flex;
                        align-items: center;
                        height: torem(64);
                        border-bottom: torem(1) solid rgba(255, 255, 255, 0.1);
                        padding: 0 torem(12);
                        div {
                            width: torem(110);
                        }
                        .listMainIcon {
                            &-img {
                                display: flex;
                                justify-content: center;
                                align-items: center;
                                // margin-left: 24px;
                                width: torem(36);
                                height: torem(28);
                                // background-image: url("../assets/images/rankOneIcon.png");
                                background-size: cover;
                                span {
                                    font-size: torem(12);
                                    font-family: Plus Jakarta Sans,
                                        Plus Jakarta Sans;
                                    font-weight: 800;
                                    // @include font_color("font-color-3");
                                    color: #ffffff;
                                }
                            }
                        }
                        .listMainTest {
                            font-size: torem(14);
                            // font-family: Lato, Lato;
                            font-family: Plus Jakarta Sans, Plus Jakarta Sans;
                            font-weight: 400;
                            @include font_color("font-color-3");
                        }
                        .rankText2 {
                            // margin-left: torem(16);
                            line-height: 1.2;
                            width: torem(350);
                        }
                        .rankText3 {
                            // text-align: right;
                        }
                    }
                }
            }
        }
    }

    .rulerBox {
        border-radius: torem(12);
        @include border_color("background-color-8");
        background-color: transparent;
        .rewardModel {
            @include background_color("background-color-8");
            width: torem(300);
            min-height: torem(360);
            // border-radius: torem(12);
            padding: torem(24);
            &-main {
                &-title {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    span {
                        font-family: Lato, Lato;
                        font-weight: 600;
                        font-size: torem(16);
                        @include font_color("font-color-3");
                        line-height: torem(19);
                        letter-spacing: torem(1);
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }
                    svg {
                        width: torem(12);
                        height: torem(12);
                    }
                }
                &-content {
                    margin-top: torem(24);
                    overflow: auto;
                    height: torem(360);
                    padding: 0 torem(5);
                    p {
                        // line-height: torem(18);
                        line-height: 1.5;
                    }
                }
            }
        }
    }

    .newBox1,
    .newBox2,
    .newBox3 {
        border-radius: torem(12);
        @include border_color("background-color-8");
        background-color: transparent;
        .rewardModel {
            @include background_color("background-color-8");
            width: torem(300);
            min-height: torem(360);
            // border-radius: torem(12);
            padding: torem(24);
            &-main {
                &-title {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    span {
                        font-family: Lato, Lato;
                        font-weight: 600;
                        font-size: torem(16);
                        @include font_color("font-color-3");
                        line-height: torem(19);
                        letter-spacing: torem(1);
                        text-align: left;
                        font-style: normal;
                        text-transform: none;
                    }
                    svg {
                        width: torem(12);
                        height: torem(12);
                    }
                }
                &-content {
                    margin-top: torem(24);
                    overflow: auto;
                    height: torem(360);
                    // padding: 0 torem(5);
                    @include font_color("font-color-5");
                    line-height: 1.5;
                    font-size: torem(14);
                }
            }
        }
    }

    .tip-popup {
        text-align: center;
        @include background_color("background-color-8");
        svg {
            width: torem(33);
            height: torem(33);
        }
        p {
            @include sc(torem(14), #333);
            line-height: 1.5;
            margin: torem(16) 0 torem(24);
            @include font_color("font-color-3");
        }
        /deep/ .van-button {
            width: 100%;
            height: torem(44);
            @include sc(torem(16), #333);
            // background-color: #ffc72b;
            border: none;
            border-radius: torem(4);
        }
        .cancalBtn {
            margin-top: torem(8);
            @include background_color("background-color-9");
            @include font_color("font-color-3");
        }
        .confirmBtn {
            background-color: #ffc72b;
        }
    }

    .sucPointsBox {
        background-color: transparent;
        height: torem(441);
        .finishModel {
            width: torem(303);
            // height: torem(441);
            &-img {
                display: flex;
                flex-direction: column;
                background-size: cover;
                // background-image: url("../assets/images/contractPoint/sevenFinishBg.svg");
                height: torem(400);
                span {
                    width: 100%;
                    text-align: center;
                    font-family: Lato, Lato;
                    font-weight: bold;
                    font-size: 24px;
                    color: rgba(0, 0, 0, 0.9);
                    line-height: 24px;
                    font-style: normal;
                    text-transform: none;
                    margin-top: torem(70);
                    // padding-left: 34px;
                }
                .getPoints_box {
                    height: torem(240);
                    padding-top: torem(12);
                    text-align: center;
                    .span_1 {
                        font-family: Lato, Lato;
                        font-weight: 800;
                        font-size: torem(40);
                        color: #000922;
                        line-height: torem(60);
                        text-align: center;
                        font-style: normal;
                        text-transform: none;
                    }
                    .span_2 {
                        font-size: torem(16);
                        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                        color: rgba(0, 0, 0, 0.8);
                    }
                }
                .finishModelBtn {
                    margin-top: 40px;
                }
                .again {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    border-radius: torem(4);
                    // left: torem(26);
                    width: torem(248);
                    height: torem(40);
                    background-color: rgba(0, 0, 0, 0.9);
                    font-size: torem(16);
                    font-family: Source Han Sans CN-Medium, Source Han Sans CN;
                    font-weight: 500;
                    color: rgba(255, 255, 255, 0.85);
                    cursor: pointer;
                }
            }
            .finishModelIcon {
                display: flex;
                // margin: 0 auto;
                position: absolute;
                // left: 47%;
                width: torem(18);
                height: torem(18);
                margin-top: torem(21);
                cursor: pointer;
            }
            // &-fa {
            //     .finishModel-img {
            //         // background-image: url("../assets/images/contractPoint/sevenFinishBg-fa.svg");
            //         background-image: url("../assets/images/contractPoint/sevenFinishBg.svg");
            //         height: torem(400);
            //     }
            // }
        }
    }

    .tranBox {
        position: absolute;
        width: torem(40);
        height: torem(23);
        // border: 1px solid red;
        z-index: 99;
    }
    .boxIcon {
        margin: 0 auto;
    }
    .emptyIcon {
        width: torem(50);
        // height: torem(50);
        // margin: torem(20) 0;
    }
    /deep/ .van-empty__description {
        margin-top: torem(5);
    }
    /deep/ .van-empty__image {
        display: flex;
        justify-content: center;
        width: torem(90);
        height: torem(40);
    }
    .frHeaderText {
        margin-left: torem(20);
    }
    .frHeaderText1 {
        margin-left: torem(19);
    }
    .lastItem {
        border-bottom: 1px solid transparent !important;
    }
    .rulerArw {
        font-size: torem(12);
    }
    ::-webkit-scrollbar {
        display: none;
    }
    .bottomBox {
        height: torem(30);
        @include background_color("background-color-4");
    }
    .headerText {
        margin-top: 12px;
        font-family: Lato, Lato;
        font-weight: 400;
        font-size: 18px;
        @include font_color("font-color-5");
        line-height: 21px;
    }
    .tishigantan {
        width: torem(15) !important;
        height: torem(15) !important;
    }
    .rankTable {
        font-size: torem(14);
        // border-collapse: collapse;
        margin-top: torem(16);
        // border-color: red !important;
        // border: torem(1) solid !important;
        // @include border_color("background-color-5");
        td {
            font-size: torem(14);
            // @include border_color("background-color-5");
            // font-size: 11px;
            border: torem(1) solid;
            @include border_color("background-color-5");
            width: torem(127);
            height: torem(32);
            // padding-left: torem(8);
            word-break: break-all;
            /* 当单词太长时进行断开处理 */
            overflow-wrap: break-word;
            /* 当单词超出边界时进行换行 */
        }
        .rankTd2 {
            // text-align: right;
            // padding-right: torem(8);
        }
    }
    .levelTitle {
        margin-top: torem(16);
        display: flex;
        justify-content: center;
        align-items: center;
        // width: torem(252);
        height: torem(32);
        @include background_color("background-color-7");
        font-family: Lato, Lato;
        font-weight: 400;
        font-size: torem(12);
        color: #7f8490;
    }
    .invTable {
        // width: torem(252);
        // border: torem(1) solid !important;
        // @include border_color("background-color-5");
        td {
            border: torem(1) solid;
            @include border_color("background-color-5");
            // font-size: 11px;
            width: torem(127);
            height: torem(32);
            // padding-left: torem(8);
            font-size: torem(11);
        }
        .td1 {
            width: torem(60);
        }
        .td2 {
            width: torem(56);
            // overflow-wrap: break-word; /* 在单词之间换行 */
        }
        .td3 {
            width: torem(134);
        }
    }
    .dayBorder {
        border-color: red !important;
    }
    .moonBorder {
        border: torem(1) solid rgba(255, 255, 255, 0.05) !important;
    }
    .ruLangShdowText {
        font-size: torem(20) !important;
    }
</style>


// WEBPACK FOOTER //
// src/view/contractPoint.vue